/* istanbul ignore file */

import { registerLibrary } from '@tr/app-information';
import { executeSideEffects } from './tr-id-stitch.js';

/**
 * Tr Id stitch library - is a package to extract ECID and SHA256 hash of an email address and provide it for meta data mapping in Pendo. The package internally loads adobe's **VisitorAPI.js** and uses it extract the data from adobe.
 *
 * @packageDocumentation
 */
export type { VisitorValues, IdStitchObject } from './tr-id-stitch.js';
export { getIdStitchValues, testHealth } from './tr-id-stitch.js';

registerLibrary({
	name: '@tr/tr-id-stitch',
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	version: (globalThis as any).VERSION,
});
executeSideEffects();
